import React from 'react'
import { LandingPageImport } from '../Import'
const { Clock4, Mail, PhoneCall, TextAnimate, Form, Button, FloatingLabel } = LandingPageImport

export default function ContactUs() {
    return (
        <>
            <div className="contact padding-100">
                <div className="container">
                    <div className="row align-items-center">

                        <div className="col-lg-5">
                            <div className="message" data-aos="zoom-in" data-aos-duration="1000">

                                <div className="hero_sub_title">
                                    <h2 style={{ margin: 'inherit' }}>LEAVE A MESSAGE</h2>
                                </div>

                                <Form onSubmit={(e) => { e.preventDefault(); }} className='mt-4 mb-4'>

                                    <div className="row">

                                        <div className="col-6">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Name"
                                                className="contact_form_label mb-3"
                                            >
                                                <Form.Control type="text" placeholder="name@example.com" className='contact_form' />
                                            </FloatingLabel>
                                        </div>

                                        <div className="col-6">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Phone"
                                                className="contact_form_label mb-3"
                                            >
                                                <Form.Control type="number" placeholder="name@example.com" className='contact_form' />
                                            </FloatingLabel>
                                        </div>

                                        <div className="col-12">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Email"
                                                className="contact_form_label mb-3"
                                            >
                                                <Form.Control type="email" placeholder="name@example.com" className='contact_form' />
                                            </FloatingLabel>
                                        </div>

                                        <div className="col-12">
                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Subject"
                                                className="contact_form_label mb-3"
                                            >
                                                <Form.Control type="text" placeholder="name@example.com" className='contact_form' />
                                            </FloatingLabel>
                                        </div>

                                        <div className="col-12">
                                            <FloatingLabel
                                                controlId="floatingTextarea"
                                                label="Message"
                                                className="contact_form_label mb-3"
                                            >
                                                <Form.Control as="textarea" placeholder="Leave a comment here" style={{ height: '100px' }} className='contact_form' />
                                            </FloatingLabel>
                                        </div>

                                        <div className="col-12">
                                            <Button
                                                type='submit'
                                                size='sm'
                                                className='common_btn mt-3'
                                            >
                                                Send
                                            </Button>
                                        </div>

                                    </div>

                                </Form>

                            </div>
                        </div>

                        <div className="col-lg-1"></div>

                        <div className="col-lg-6">
                            <div className='hero_title'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    HOW TO REACH
                                </h5>
                            </div>

                            <div className="hero_sub_title">
                                <h2><TextAnimate text="Connect with Our Team" /></h2>

                                <p style={{ color: '#FFF' }} data-aos="fade-left" data-aos-duration="900">
                                    We’re here to help! you have any questions about Innovate 2024, need assistance with registration, or want to learn more about.
                                </p>
                            </div>

                            <div className="contact-author-box" data-aos="fade-left" data-aos-duration="1000">
                                <div className="icons">
                                    <Mail />
                                </div>
                                <div className="text">
                                    <h4>Our Email</h4>
                                    <a href="mailto:hello@wrricconnect.org">hello@wrricconnect.org</a>
                                </div>
                            </div>

                            <div className="contact-author-box" data-aos="fade-left" data-aos-duration="1100">
                                <div className="icons">
                                    <PhoneCall />
                                </div>
                                <div className="text">
                                    <h4>Call/Message</h4>
                                    <a href="tel:+918447157365">+91 84471-57365</a>
                                </div>
                            </div>

                            <div className="contact-author-box" data-aos="fade-left" data-aos-duration="1200">
                                <div className="icons">
                                    <Clock4 />
                                </div>
                                <div className="text">
                                    <h4>Schedule</h4>
                                    <a href="mailto:hello@wrricconnect.org">Sunday-Friday: 9 AM – 6 PM</a>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className='contact_map'>
                                <iframe
                                    width="100%"
                                    height="300"
                                    style={{ borderRadius: '8px' }}
                                    loading="lazy"
                                    allowFullScreen
                                    referrerPolicy="no-referrer-when-downgrade"
                                    src="https://www.google.com/maps?q=21.1458,79.0882&z=5&output=embed">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
